module.exports = __webpack_public_path__ + "cf287a7edbd454f528fc0d520fdb9b80.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-44@2x.png
// module id = 518
// module chunks = 0